import { I18n } from "aws-amplify/utils";

import { fi } from "./fi.ts";

const dict = {
  fi,
};

export const languages = {
  en: {
    code: "en",
    name: "English",
  },
  fi: {
    code: "fi",
    name: "Suomi",
  },
};

export const setupI8n = () => {
  I18n.putVocabularies(dict);
};
